export namespace VehicleTypeConstants {
  export const SEDAN = 'SED';
  export const SUV = 'SUV';
  export const WAV = 'WAV';

  export const VEHICLE_TYPE_CODE_BASIC = 'BAS';
  export const VEHICLE_TYPE_CODE_WAV = 'WAV';

  export const VEHICLE_TYPE_NAME_BASIC = 'Basic';
  export const VEHICLE_TYPE_NAME_WAV = 'Wheelchair Accessible Vehicle';
}
